import { useReactToPrint } from 'react-to-print'
import { useRef } from 'react'

export const usePrint = () => {
  const contentRef = useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return { reactToPrintFn, contentRef }
}
